// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"65":"93847ef9","72":"fd3c697e","377":"8eca5ab4"}[chunkId] + ".js";
};